import { Box, List } from '@mui/joy'
import { getSelector } from '@utils/getSelector'
import { useEffect } from 'react'

const adList = [
	'//adex.ednplus.com/xc/h/uJUHEKCS',
	'//adex.ednplus.com/xc/h/uJVrc85C',
	'//adex.ednplus.com/xc/h/uJVADG4J',
]
const ShoppingLife = () => {
	const drawAd = (li: HTMLLIElement, index: number) => {
		// eslint-disable-next-line no-param-reassign
		li.innerHTML = `<iframe
					src="${adList[index]}"
					width="200"
					height="200"
					frameBorder="0"
					scrolling="no"
					referrerPolicy="no-referrer-when-downgrade"
					marginWidth="0"
					marginHeight="0"
					hspace="0"
					vspace="0"
				/>`
	}
	useEffect(() => {
		const content = getSelector('#ednp_content')
		if (content) {
			const list = content.querySelectorAll('li')
			list.forEach(drawAd)
		}
	}, [])
	return (
		<Box
			id="ednp_wrap"
			className="print-hide"
			display={{
				xs: 'none',
				md: 'block',
			}}
			sx={{
				padding: '13px 0 9px 0',
				border: '1px solid #ddd',
			}}
		>
			<Box
				id="ednp_logo"
				sx={{
					'& img': {
						margin: '0 auto',
					},
				}}
			>
				<img
					src="https://img.iacstatic.co.kr/adbayimg/templates/trand_logo.gif"
					alt="SHOPPING & LIFE"
				/>
			</Box>
			<Box id="ednp_content">
				<List
					sx={{
						margin: '10px 0 0 0',
						padding: 0,
						justifyContent: 'center',
						flexDirection: 'row',
						'& > li': {
							display: 'inline-block',
							width: '200px',
							height: '200px',
							backgroundColor: '#ccc',
							listStyle: 'none',
							marginLeft: '10px',
							'&:first-child': {
								marginLeft: 0,
							},
						},
					}}
				>
					<li />
					<li />
					<li />
				</List>
			</Box>
		</Box>
	)
}
export default ShoppingLife
